var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-layer full-layer"},[_vm._v(" 游戏开始 ")])}
var staticRenderFns = []

export { render, staticRenderFns }